import { Tooltip } from '@common-web/index';
import { formatCurrency, formatNumbers, ifValueExists, numberToWords } from '@utils/utils';
import { useSelector } from 'react-redux';

const CompactNumber = ({
  value,
  isCurrency = false,
  negative = false,
  round = true,
  showNumberInWords = true,
  compact = true,
  ...props
}) => {
  const { currency } = useSelector((state) => state?.tenantData?.tenant ?? {});
  if (!ifValueExists(value)) {
    return <span {...props}>-</span>;
  }

  const formattedFullUnrounded = isCurrency
    ? formatCurrency({ price: value, currency, negative, round: false })
    : formatNumbers(value, false);

  const formattedFull = isCurrency
    ? formatCurrency({ price: value, currency, negative, round })
    : formatNumbers(value, round);

  const formattedCompact = isCurrency
    ? formatCurrency({ price: value, currency, compact: true, round, negative })
    : formatNumbers(value, round, true);
    
  const rawValue = value;
  const numericValue = typeof rawValue === 'string' ? Number(rawValue.replace(/,/g, '')) : Number(rawValue);
  const shouldShowTooltip = numericValue >= 1000000 && compact && round;
  const displayValue = compact ? formattedCompact : formattedFull;

  return (
    <Tooltip
      title={
        shouldShowTooltip ? (
          <div>
            <span className="fw-600">{formattedFullUnrounded}</span>
            {showNumberInWords && value >= 1000000 && (
              <>
                <br />
                <span>{numberToWords(Math.round(value))}</span>
              </>
            )}
          </div>
        ) : null
      }
    >
      <span {...props}>{displayValue}</span>
    </Tooltip>
  );
};

export default CompactNumber;
